import React from 'react';
import './WebsiteFeatures.scss';

import { motion } from 'framer-motion';

import { homePage } from '../../../editable-stuff/config';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

export default function WebsiteFeatures() {
  return (
    <section id='website-features' className='p-150'>
      <div className='wave-top' style={{ height: '50px' }}>
        <svg
          fill='#f6f6f6'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 1000 300'
          preserveAspectRatio='none'
        >
          <path d='M 1000 299 l 2 -279 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -232 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z'></path>
          <path d='M 1000 286 l 2 -252 c -157 -43 -302 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -145.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 10.61 v 22.39 z'></path>
          <path d='M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z'></path>
        </svg>
      </div>
      <div className='container'>
        <div className='headers text-center mb-8'>
          <motion.h4
            initial={{ y: '100px', opacity: 0 }}
            whileInView={{ y: '0', opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            {homePage.websiteFeatures.title}
          </motion.h4>
          <motion.h2
            className='gradient'
            initial={{ y: '100px', opacity: 0 }}
            whileInView={{ y: '0', opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            {homePage.websiteFeatures.gradient_title}
          </motion.h2>
        </div>
        <div className='row no-gutters'>
          <div className='col-12'>
            <motion.div
              className='features-swiper'
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <Swiper
                spaceBetween={60}
                slidesPerView={1}
                loop={false}
                speed={1000}
                pagination={{ clickable: true }}
                modules={[Pagination]}
                breakpoints={{
                  // when window width is >= 600px
                  600: {
                    slidesPerView: 2,
                    spaceBetween: 60,
                  },
                  // when window width is >= 800px
                  800: {
                    slidesPerView: 3,
                    spaceBetween: 60,
                  },
                }}
              >
                {homePage.websiteFeatures.features?.map((feature) => (
                  <SwiperSlide>
                    {feature.svg}
                    <h4>{feature.title}</h4>
                    <div className='content'>
                      <p>{feature.content}</p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
